import React from 'react';
import ClickSelectText from '../ClickSelectText';
import { getFlag } from '../../config/flags';
import classnames from 'classnames';

class FlowEditorDetails extends React.Component {

    selectAllText({ target }) {
        const range = document.createRange();
        range.selectNode(target);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
    }

    render() {

        let dateModifiedCaption = null;

        if (this.props.dateModified) {
            const dateModified = moment(this.props.dateModified);
            dateModifiedCaption = 'Last Modified: ' + moment(dateModified.toDate()).format('YYYY-MM-DD HH:mm:ss');
        }

        const classes = classnames({
            'flow-editor-details': true,
            'new-canvas': getFlag('canvas'),
        });

        return (
            <div className={classes}>
                <span>ID: <ClickSelectText text={ this.props.id } /></span>
                <span>Version ID: <ClickSelectText text={ this.props.versionId } /></span>
                <span className="flow-last-modified">{dateModifiedCaption}</span>
                {getFlag('canvas') ? null : <span>Ctrl + H for help</span>}
            </div>
        );

    }

}

export default FlowEditorDetails;
